import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
   static targets = [ "list", "template" ];
   static outlets = [ "modal" ];

   connect() {
      this.form = this.modalOutlet.element.querySelector("form");
      this.submitHandler = (event) => {
         event.preventDefault();

         // read form values
         const formData = new FormData(this.form);
         const entryId = formData.get("entry_id");
         const originElementId = formData.get("importing_v3_sub_element_link[origin_element_id]");
         const selectedTargetElement = formData.get("importing_v3_sub_element_link[element]");

         if (originElementId || selectedTargetElement) {
            const normalizedSelectedTargetElement = (selectedTargetElement || "");
            const elementType = normalizedSelectedTargetElement.split("=")[0];
            const elementId = normalizedSelectedTargetElement.split("=")[1];

            // add selected form value as new sub element to list
            const nextListIndex = this.listTarget.childElementCount;
            let linkText = '';
            if (originElementId) {
               linkText += originElementId;
            }
            if (originElementId && !selectedTargetElement) {
               linkText += ' <-';
            }
            if (originElementId && selectedTargetElement) {
               linkText += ' <-> ';
            }
            if (!originElementId && selectedTargetElement) {
               linkText += '-> ';
            }
            if (elementType === 'area_id') {
               linkText += `[A ${elementId}]`;
            }
            else if (elementType === 'classification_id') {
               linkText += `[C ${elementId}]`;
            }

            let newListElement = this.templateTarget.innerHTML.replace(/ENTRY_ID/g, entryId);
            newListElement = newListElement.replace(/NEXT_LIST_INDEX/g, nextListIndex);
            newListElement = newListElement.replace(/ORIGIN_ELEMENT_ID/g, originElementId);
            newListElement = newListElement.replace(/SELECTED_TARGET_ELEMENT/g, selectedTargetElement);
            newListElement = newListElement.replace(/LINK_TEXT/g, linkText);

            this.listTarget.insertAdjacentHTML("beforeend", newListElement);
         }

         this.form.reset();
         this.modalOutlet.close();
      };
      this.form.addEventListener("submit", this.submitHandler);
   }

   disconnect() {
      this.form.removeEventListener("submit", this.submitHandler);
   }

   add() {
      this.modalOutlet.show();
   }

   remove(event) {
      const item = event.target.closest("li")
      item.remove();
   }

}
